import Cookie from 'js-cookie';

import { BYBIT_GUID_KEY } from './constants';
const cookieDomain = 'bybit.com';

export function s4() {
  return Math.floor((1 + Math.random()) * 0x10000)
    .toString(16)
    .substring(1);
}

export function generateGuid() {
  return `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
}

export function getGuid() {
  let guid = Cookie.get(BYBIT_GUID_KEY);
  if (!guid || guid.length !== 36) {
    guid = generateGuid();
  }
  // Do this to refresh cookie's remaining time.
  Cookie.set(BYBIT_GUID_KEY, guid, {
    expires: 120,
    path: '/',
    domain: cookieDomain,
  });

  return guid;
}
